import { Component, OnInit, Input } from '@angular/core';
import { TacticCampaignProgramDescriptionDto } from 'app/client-core/dtos/tactics.model';
import { ProgramId } from 'app/client-core/dtos/programs.model';
import { LayoutService } from 'app/shared/layout/layout.service';
import { ProgramEmailModalComponent } from 'app/+campaign-library/email-modal/asset-email.modal.component';
import { BsModalService } from 'ngx-bootstrap';
import { ProgramService } from 'app/client-core/services/program.service';
import { Router } from '@angular/router';
import { PrintModalComponent } from '../print/create.modal.component';

@Component({
  selector: 'app-program-top-info',
  templateUrl: './program-top-info.component.html',
  styleUrls: ['./program-top-info.component.scss']
})
export class ProgramTopInfoComponent implements OnInit {
  @Input() program: TacticCampaignProgramDescriptionDto = new TacticCampaignProgramDescriptionDto();
  @Input() programId: number;
  @Input() hideInfoIcon: boolean;
  @Input() showPdfIcon: boolean;
  @Input() showBackButton: boolean;
  createPlanModal: any;

  constructor(
    private layoutService: LayoutService,
    private modalService: BsModalService,
    private programService: ProgramService,
    private router: Router
  ) { }

  ngOnInit() {
    if (this.programId) {
      this.programService.getProgramDetailsFor(this.programId)
        .subscribe(res => {
          console.log('getProgram res', res);
          if (!res.hasError) {
            this.program = res.data;
          }
        });
    }
  }

  selectProgram(dto: TacticCampaignProgramDescriptionDto): void {
    this.layoutService.showCreateCampaignThemeInfo.next({ campaignId: this.program.campaignThemeId, programId: this.program.id });
  }

  notify() {
    const initialState = { programId: this.program.id }
    // tslint:disable-next-line:max-line-length
    this.modalService.show(ProgramEmailModalComponent, Object.assign({}, {
      animated: true,
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg'
    }, { initialState })
    );
  }

  private viewCampaignThemeModalConfig = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "modal-lg"
  };
  print() {
    this.programService.getProgramDetails(this.programId, false).subscribe(response => {
      const initialState = {
        programDetailsDto: response.data
      }
  
      // tslint:disable-next-line:max-line-length
      this.createPlanModal = this.modalService.show(PrintModalComponent, Object.assign({}, { ...this.viewCampaignThemeModalConfig, class: 'modal-elg' }, { initialState }));
    });
  }

  navigateBack() {
    this.router.navigateByUrl(`/tactic-catalog/${this.programId}`)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/program-top-info/program-top-info.component.ts